import React from 'react';
import { Link } from 'react-router-dom';

const OtherPortfolioPage = () => {
    return (
        <div className="min-h-screen bg-[#0A1128] text-[#F8F8F8] p-8 md:p-16 flex flex-col items-center justify-center text-center">
            <h1 className="text-5xl md:text-6xl font-extrabold text-[#C9B072] mb-6">
                Other Portfolio (Coming Soon!)
            </h1>
            <p className="text-xl md:text-2xl text-[#CCD2E3] max-w-3xl mb-10">
                Explore a wider range of our creative projects.
            </p>
            {/* Add content for other portfolio items */}
            <p className="text-2xl text-[#C9B072]">
                Stay tuned for more exciting projects!
            </p>
            <Link to="/graphics-design" className="mt-12 px-8 py-3 bg-[#4CAF50] text-[#0A1128] font-semibold text-lg rounded-full shadow-lg transition duration-300 transform hover:scale-105 hover:bg-opacity-90 inline-flex items-center justify-content-center">
                Back to Graphics & Design
            </Link>
        </div>
    );
};

export default OtherPortfolioPage;